//add project on top for latest
import memory from '../images/projectsicon/memory.png'
import mardigras from '../images/projectsicon/mardiGras.png';
import flights from "../images/projectsicon/flightsRoutes.png";
import googleMap from "../images/projectsicon/googleMap.png";
import finalProj from "../images/projectsicon/finalPro.png";
import reactShop from "../images/projectsicon/reactShopApi.png";
import angular from "../images/projectsicon/angular.png";
import weather from "../images/projectsicon/weatherapp.png";
import php from "../images/projectsicon/php.png";
import redux from "../images/projectsicon/reactRedux.png";
import todos from "../images/projectsicon/todos.png";
import music from "../images/projectsicon/reactMusic.png";
import rock from "../images/projectsicon/rock.png";
import chat from "../images/projectsicon/chat.png";
import crypto from "../images/projectsicon/crypto.png";
import mailbox from "../images/projectsicon/vuejs.png";
import playtube from "../images/projectsicon/playtube.png";
import fitness from "../images/projectsicon/excersise.png";
import vuedlix from "../images/projectsicon/vueflix.png";
//add project on top for latest

const portfolioData = [

  {
    image:  mardigras,
    link: 'https://quirky-montalcini-cab1ed.netlify.app',
    desc: 'Mardi Gras Festival New orleans',
    summary: 'This is my first project at HackerU colleage in web development',
    tech: 'HTML | CSS | SASS |Javascript | Jquery | Scss | Bootstrap'
  },
  {
    image:  playtube,
    link: 'https://playtube-ofek-react.netlify.app',
    desc: 'videos website with api',
    summary: 'social videos',
    tech: 'ReactJs | JavaScript | Routes-dom'
  },
  {
    image:  fitness,
    link: 'https://fityourselfbyofek.netlify.app',
    desc: 'fit yourself',
    summary: 'fitness',
    tech: 'ReactJs | JavaScript | Routes-dom | css'
  },
  {
    image:  vuedlix,
    link: 'https://vueflix-ofek.netlify.app',
    desc: 'watch movies',
    summary: 'api of movies and TVshows',
    tech: 'ReactJs | JavaScript | Routes-dom | css | api'
  },
  {
    image:  flights,
    link: 'https://pensive-bose-a76072.netlify.app',
    desc: 'flights website',
    summary: 'flights schedules ReactJs Routes',
    tech: 'ReactJs | JavaScript | Routes-dom'
  },
  {
    image:  googleMap,
    link: 'https://admiring-wescoff-b8d47f.netlify.app',
    desc: 'Google map resturant/hotels',
    summary: 'This app recreates a functional GPS system using api request',
    tech: 'RapiApi | Axios | ReactJs | JavaSript |CSS'
  },
  {
    image:  music,
    link: 'https://song23.netlify.app',
    desc: 'music app',
    summary: 'music app playing',
    tech: 'ReactJs hooks | JavaScript | CSS | Bootstrap'
  },
  
  {
    image:  reactShop,
    link: 'https://sharp-bassi-bca0c1.netlify.app',
    desc: 'react clothes shop online',
    summary: 'fashion life style',
    tech: 'HTML | CSS | JavaScript | React-Router-Dom'
  },
  {
    image:  angular,
    link: 'https://frosty-hodgkin-4df7b4.netlify.app',
    desc: 'angular search images',
    summary:'make some beats!',
    tech: 'angular | CSS | JavaScript'
  },
  {
    image:  redux,
    link: 'https://youthful-agnesi-5e4aed.netlify.app',
    desc: 'React Redux',
    summary: 'Movie list',
    tech: 'React | Redux | JavaScript | CSS '
  },
  {
    image:  chat,
    link: 'https://festive-keller-a268f3.netlify.app',
    desc: 'chat online',
    summary: ' login to chat -> username:ofekram password:123123',
    tech: 'HTML | CSS | JavaScript | ReactJs | JSX | chatEngine'
  },
  {
    image:  finalProj,
    link: 'https://infallible-goldstine-e3e0c6.netlify.app',
    desc: 'israeli events tickets',
    summary: 'poetry, entertainment',
    tech: 'HTML | CSS | JavaScript | Bootstrap | NodeJS'
  },
  {
    image:  php,
    link: 'https://musing-mestorf-bf98ce.netlify.app',
    desc: 'PHP resurant using SQL',
    summary: 'resturant menu',
    tech: 'HTML | CSS | JavaScript | PHP | SQL'
  },
  {
    image: crypto ,
    link: 'https://ctypto.netlify.app',
    desc: 'crypto details',
    summary: 'price,symbol,volume',
    tech: 'JavaScript | HTML | CSS |reactJs'
  },
  {
    image: mailbox ,
    link: 'https://emailboxvuejs.netlify.app',
    desc: 'ofek email',
    summary: 'sent,inbox,delete',
    tech: 'JavaScript | HTML | CSS |vueJs'
  },
  {
    image:  todos,
    link: 'https://elastic-jackson-ea2b01.netlify.app',
    desc: 'task meneger',
    summary: 'todos react hooks',
    tech: 'React | JavaScript'
  },
  {
    image:  memory,
    link: 'https://gifted-villani-5f1f74.netlify.app',
    desc: 'memory game Js',
    summary: 'A memory game using JavaScript,html,css',
    tech: 'JavaScript |HTML| CSS'
  },
  {
    image:  weather,
    link: 'https://reactweatherofek270899.netlify.app',
    desc: 'weather api',
    summary: 'wheateher buy writing location',
    tech: 'reacuJs | API | JavaScript | CSS'
  },
  {
    image: rock ,
    link: 'https://epic-ride-b346a8.netlify.app',
    desc: 'game vs computer',
    summary: 'rock paper scissors',
    tech: 'JavaScript | HTML | CSS'
  },
  
  
  
  

 
  
]
  
export default portfolioData;